import { convertValueToEnum, ThemeType, } from '../types';
export function resolveBaseConfig(env, appName, externalApiSources, testGroupProfiles, testGroups, testOrganisationUnits, getLogUrl, featureFlagEnvVars = {}) {
    const debug = env.APP_DEBUG === 'true';
    return {
        appName,
        buildVersion: env.APP_BUILDVERSION,
        debug,
        basePath: env.APP_BASEPATH || '/',
        baseUrl: env.APP_BASEURL,
        authPaths: {
            signIn: env.AUTH_SIGNIN_PAGE || '/',
            signOut: env.AUTH_SIGNOUT_PAGE || '/signout',
            redirectProtection: env.REDIRECT_PROTECTION?.split(',') || [
                '/400',
                '/500',
                '/autherror',
                '/error',
                '/signout',
            ], // the following url paths will not be used for a redirection after signin, but will fall back to AUTH_SIGNIN_PAGE instead
        },
        externalApiSources,
        logStepValidationErrors: env.LOG_STEP_VALIDATION_ERRORS === 'true',
        debugHelper: {
            releaseFilePath: env.DEBUGHELPER_RELEASE_FILEPATH,
            styleGuideUrl: env.DEBUGHELPER_STYLEGUIDE_URL,
            permissions: env.DEBUGHELPER_PERMISSIONS === 'true',
        },
        themeType: convertValueToEnum(env.THEMETYPE, Object.values(ThemeType)),
        getLogUrl,
        permission: {
            selectedTestGroups: [],
            selectedTestGroupProfile: [],
            selectedTestOrganisationUnits: [],
            testGroupProfiles: (debug && testGroupProfiles) || [],
            testGroups: (debug && testGroups) || [],
            testOrganisationUnits: (debug && testOrganisationUnits) || [],
        },
        featureFlagEnvVars,
        mocking: {
            apiSources: env.MOCK_API_SOURCES?.split(','),
            session: env.DANGEROUSLY_MOCK_SESSION === 'true',
        },
        gtm: env.GTM_ID
            ? {
                id: env.GTM_ID,
                preview: env.GTM_PREVIEW,
                auth: env.GTM_AUTH,
            }
            : undefined,
    };
}
